import { Ban, CircleAlert, Coins, SearchX, WifiOff, type LucideIcon } from 'lucide-react';

import type { DegradationReasonValue } from './api/schemas';
import { cm } from './messages';

/** Literal keys into the catalogue, called fresh (not memoised) so a locale switch is honoured. */
export function reasonSentence(reason: DegradationReasonValue): string {
  switch (reason) {
    case 'budget_shed':
      return cm('reason.budget_shed');
    case 'budget_window':
      return cm('reason.budget_window');
    case 'budget_hold':
      return cm('reason.budget_hold');
    case 'collection_cancelled':
      return cm('reason.collection_cancelled');
    case 'provider_unavailable':
      return cm('reason.provider_unavailable');
    case 'provider_not_found':
      return cm('reason.provider_not_found');
    case 'collection_failed':
      return cm('reason.collection_failed');
  }
}

/** Decoration only: the sentence is the reason, so no icon carries a meaning the text lacks. */
export const REASON_ICON: Record<DegradationReasonValue, LucideIcon> = {
  budget_shed: Coins,
  budget_window: Coins,
  budget_hold: Coins,
  collection_cancelled: Ban,
  provider_unavailable: WifiOff,
  provider_not_found: SearchX,
  collection_failed: CircleAlert,
};
